export default __webpack_public_path__ + "static/media/SourceSansPro-SemiBold.bf2cc5b7.woff";